import { associarEmailGuard, restricaoGuard, roleGuard, secretarioDeInformaticaGuard } from './helpers/router-helpers'
import Vue from 'vue'
import Router from 'vue-router'
import {
	authGuard,
	noAuthGuard,
} from '@/helpers/router-helpers'
import { authModule, userModule } from './store'
import { PERMISSOES_ADICIONAR_EVENTO } from './shareds/sharedsEvento'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'landing',
			component: require('@/views/Landing.vue').default,
			beforeEnter: noAuthGuard,
		},
		{
			path: '/login',
			name: 'login',
			component: require('@/views/Login.vue').default,
			beforeEnter: noAuthGuard,
		},
		{
			path: '/esqueci-senha',
			name: 'esqueci-senha',
			component: require('@/views/auth/EsqueciSenha.vue').default,
			beforeEnter: noAuthGuard,
		},
		{
			// URL de ação dos e-mails do Firebase (definir senha, confirmar e-mail); sem guarda para funcionar com sessão aberta
			path: '/acao-de-conta',
			name: 'acao-de-conta',
			component: require('@/views/auth/AcaoDeConta.vue').default,
		},
		{
			path: '/associar-email',
			name: 'associar-email',
			component: require('@/views/auth/AssociarEmail.vue').default,
			beforeEnter: associarEmailGuard,
			props: () => ({ usuario: userModule.currentUser }),
		},
		{
			path: '/revalidacao-de-palavra',
			name: 'revalidacao-de-palavra',
			component: require('@/views/RevalidacaoDePalavra.vue').default,
			beforeEnter: restricaoGuard('revalidar-palavra'),
			props: () => ({ usuario: authModule.usuarioTemporario })
		},
		{
			path: '/aceite-de-termos',
			name: 'aceite-de-termos',
			component: require('@/views/auth/AceiteDeTermos.vue').default,
			beforeEnter: restricaoGuard('aceitar-termos'),
			props: () => ({ usuario: authModule.usuarioTemporario })
		},
		{
			path: '/home',
			name: 'home',
			meta: { permiteVisitante: true },
			component: require('@/views/Home.vue').default,
			beforeEnter: authGuard,
		},
		{
			path: '/busca',
			name: 'busca',
			meta: { permiteVisitante: true },
			component: require('@/views/Busca/Busca.vue').default,
			beforeEnter: authGuard,
		},
		{
			path: '/agenda',
			name: 'agenda',
			meta: { permiteVisitante: true },
			components: {
				default: require('@/views/agenda/Agenda.vue').default,
				navigation: require('@/views/agenda/AgendaToolbar.vue').default,
				['navigation-expanded']: require('@/views/agenda/AgendaToolbarExpanded.vue').default,
			},
			beforeEnter: authGuard,
		},
		{
			path: '/agenda/importar',
			name: 'importar-eventos',
			component: require('@/views/agenda/ImportarEventos.vue').default,
			beforeEnter: roleGuard(PERMISSOES_ADICIONAR_EVENTO),
		},
		{
			path: '/evento/novo',
			name: 'novo-evento',
			beforeEnter: authGuard,
			component: require('@/views/agenda/FormEvento.vue').default,
			props: { novo: true },
		},
		{
			path: '/evento/:id/editar',
			name: 'editar-evento',
			beforeEnter: authGuard,
			component: require('@/views/agenda/FormEvento.vue').default,
			props: true,
		},
		{
			path: '/evento/:id',
			name: 'detalhar-evento',
			meta: { permiteVisitante: true },
			beforeEnter: authGuard,
			component: require('@/views/agenda/DetalharEvento.vue').default,
			props: true,
		},
		{
			path: '/p/:token',
			name: 'escanear-presenca',
			meta: { permiteVisitante: true },
			beforeEnter: authGuard,
			component: require('@/views/agenda/EscanearPresenca.vue').default,
			props: true,
		},
		{
			path: '/admin',
			name: 'admin',
			component: require('@/views/Admin.vue').default,
			beforeEnter: authGuard,
		},
		{
			path: '/irmaos/novo',
			name: 'novo-irmao',
			components: {
				default: require('@/views/irmaos/FormIrmao/FormIrmao.vue').default,
			},
			beforeEnter: authGuard,
			props: {
				default: { novo: true},
			},
		},
		{
			path: '/irmaos/:id/editar',
			name: 'editar-irmao',
			components: {
				default: require('@/views/irmaos/FormIrmao/FormIrmao.vue').default,
			},
			beforeEnter: authGuard,
			props: {
				default: true,
			},
		},
		{
			path: '/irmaos/:id',
			name: 'detalhar-irmao',
			meta: { permiteVisitante: true },
			component: require('@/views/irmaos/DetalharIrmao/DetalharIrmao.vue').default,
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/visitantes/novo',
			name: 'novo-visitante',
			component: () => import('@/views/visitantes/FormVisitante.vue'),
			beforeEnter: secretarioDeInformaticaGuard,
		},
		{
			path: '/lojas/novo',
			name: 'nova-loja',
			component: require('@/views/lojas/FormLoja.vue').default,
			beforeEnter: authGuard,
			props: { novo: true },
		},
		{
			path: '/lojas/:id/editar',
			name: 'editar-loja',
			component: require('@/views/lojas/FormLoja.vue').default,
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/lojas/:id',
			name: 'detalhar-loja',
			component: require('@/views/lojas/DetalharLoja.vue').default,
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/potencias/novo',
			name: 'nova-potencia',
			component: require('@/views/potencias/FormPotencia.vue').default,
			beforeEnter: authGuard,
			props: { novo: true },
		},
		{
			path: '/potencias/:id/editar',
			name: 'editar-potencia',
			component: require('@/views/potencias/FormPotencia.vue').default,
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/potencias/:id',
			name: 'detalhar-potencia',
			component: () => import('@/views/potencias/DetalharPotencia.vue'),
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/somares/:id/editar',
			name: 'editar-somar',
			component: () => import('@/views/somares/FormSomar.vue'),
			beforeEnter: roleGuard('admin'),
			props: true,
		},
		{
			path: '/somares/:id/editar-diretoria',
			name: 'editar-diretoria',
			component: () => import('@/views/somares/FormDiretoria/FormDiretoria.vue'),
			beforeEnter: roleGuard('admin'),
			props: true,
		},
		{
			path: '/historicos/:id',
			name: 'editar-historico',
			component: () => import('@/views/somares/FormDiretoria/FormDiretoria.vue'),
			beforeEnter: roleGuard('admin'),
			props: true,
		},
		{
			path: '/historicos/novo',
			name: 'novo-historico',
			component: () => import('@/views/somares/FormDiretoria/FormDiretoria.vue'),
			beforeEnter: roleGuard('admin'),
			props: route => ({ novo: true, idSomar: route.query.idSomar }),
		},
		{
			path: '/somares/:id',
			name: 'detalhar-somar',
			component: () => import('@/views/somares/DetalharSomar/DetalharSomar.vue'),
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/candidatos',
			name: 'candidatos',
			component: () => import('@/views/candidatos/Candidatos.vue'),
			beforeEnter: authGuard,
		},
		{
			path: '/candidatos/novo',
			name: 'novo-candidato',
			component: () => import('@/views/candidatos/EditarCandidato.vue'),
			beforeEnter: authGuard,
			props: { novo: true },
		},
		{
			path: '/candidatos/:id/editar',
			name: 'editar-candidato',
			component: () => import('@/views/candidatos/EditarCandidato.vue'),
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/candidatos/:id',
			name: 'candidato',
			component: () => import('@/views/candidatos/Candidato.vue'),
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/arquivos',
			name: 'arquivos',
			component: () => import('@/views/arquivos/Arquivos.vue'),
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '/relatorios',
			name: 'relatorios',
			component: () => import('@/views/relatorios/Relatorios.vue'),
			beforeEnter: authGuard,
		},
		{
			path: '/relatorios/cargos',
			name: 'relatorio-de-cargos',
			component: () => import('@/views/relatorios/RelatorioDeCargos.vue'),
			beforeEnter: authGuard,
		},
		{
			path: '/relatorios/candidatos',
			name: 'relatorio-de-candidatos',
			component: () => import('@/views/relatorios/RelatorioDeCandidatos.vue'),
			beforeEnter: authGuard,
		},
		{
			path: '/servicos/novo',
			name: 'novo-servico',
			component: () => import('@/views/servicos/FormServico.vue'),
			beforeEnter: authGuard,
			props: { novo: true },
		},
		{
			path: '/servicos/:id',
			name: 'editar-servico',
			component: () => import('@/views/servicos/FormServico.vue'),
			beforeEnter: authGuard,
			props: true,
		},
		{
			path: '*',
			redirect: { name: 'landing' },
		},
	],
})


export default router
